import { chatQueryKeys as e } from "./useChatQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminSupportChatApi as n } from "@maat/api-chat";
//#region src/hooks/useAdminSupportConversationQuery.ts
var r = (r) => t({
	queryKey: e.adminSupportConversation(r ?? ""),
	queryFn: () => n.getConversation(r),
	enabled: !!r
});
//#endregion
export { r as useAdminSupportConversationQuery };
